import {
  AuthorizedUiElementService,
  AuthorizedUiElementConfig,
} from "../../../../../../../ui/authorizedUiElement";
import { vsServiceName as contractDetailTabsServiceName } from "./contractDetailTabsService";

export class ContractDetailTabsController {
  static $inject = [contractDetailTabsServiceName];
  constructor(
    private readonly contractDetailTabsService: AuthorizedUiElementService<AuthorizedUiElementConfig>
  ) {}

  getTabs(): AuthorizedUiElementConfig[] {
    return this.contractDetailTabsService.getConfigs();
  }
}
